import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_model/user';
import {Lookup} from '../../_model/Lookup';
import {FileNameData} from '../../_model/FileNameData';
import {Requests} from "../../_model/Requests";
import {RequestService} from "../../_services/request.service";

@Component({
    selector: 'app-requestsApprove',
    templateUrl: './requestsApprove.component.html',
    styleUrls: ['./requestsApprove.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule
    ]
})
export class RequestsApproveComponent implements OnInit {

    request: WfApproveRequest = new WfApproveRequest();
    currentUser: User;
    lookupList: Lookup[];
    fileList: FileNameData[] = [];



    constructor(public dialogRef: MatDialogRef<RequestsApproveComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests,
                private authService: AuthenticationService,
                private requestsService: RequestService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }

    closeModal(){
        this.dialogRef.close();
    }

    approveAbsence() {

        this.request.employeeId = this.currentUser.employeeId;
        this.request.operationRecordId = this.data.id;
        this.request.operationTableName = 'REQUESTS';
        this.requestsService.approveRequests(this.request).subscribe(result => {
            this.toastr.success('Onaylama işlemi başarılı', '');
            this.dialogRef.close(true);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close(false);
        });
    }
}
